import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	currentZoom: number; // 1 = 100%
	onChange: (zoomIn: boolean) => void;
}

export default class GoalsTreeZoomComponent extends Component<Args> {
	get shownZoom() {
		return Math.round(this.args.currentZoom * 100);
	}

	@action
	increaseZoom() {
		this.args.onChange(true);
	}

	@action
	decreaseZoom() {
		this.args.onChange(false);
	}
	<template>
		<div class="zoom">
			<a class="icon" {{on "click" this.increaseZoom}}>
				<CommonUiIconComponent @name="Plus" @size="sm" />
			</a>
			<span>{{this.shownZoom}}%</span>
			<a class="icon" {{on "click" this.decreaseZoom}}>
				<CommonUiIconComponent @name="Minus" @size="sm" />
			</a>
		</div>
	</template>
}
